import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxChartsModule }from '@swimlane/ngx-charts';
import { GridModule, ColumnChooserService,ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { PageService, FilterService } from '@syncfusion/ej2-angular-grids';
import {  NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { GetComingDueAuthService } from './dashboardauth.service';
import { GetHTTPService } from './dashboardumpi.service';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
import { NgxPaginationModule } from 'ngx-pagination';
@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
   NgxUiLoaderModule,
   MyDatePickerModule,
    NgxChartsModule,
    MaskedTextBoxModule,
    DashboardRoutingModule,
    dropdownModule,
    NgxPaginationModule
  ],
  providers: [ GetHTTPService,GetComingDueAuthService,ColumnChooserService,SortService,FilterService,PageService,ResizeService ]
})
export class DashboardModule { }
